module.exports = __webpack_public_path__ + "img/2022.3e6daa35.jpg";